
import Vue from "vue";
import VueRouter from "vue-router";

import store from "../store";

import publicRoutes from "./routes.public";
// import clientRoutes from "./routes.client";
import adminRoutes from "./routes.admin";

import { createGuards } from "./guards";

Vue.use(VueRouter);

// Combine application routes
const routes = [
  ...publicRoutes,
  // ...clientRoutes,
  ...adminRoutes,

  // 404 page
  {
    path: "*",
    name: "not-found",
    component: () =>
      import("../components/common/NotFound.vue"),
    meta: {
      layout: "public",
    },
  },

  {
    path: "/403",
    name: "forbidden",
    component: () =>
      import("../components/common/Forbidden.vue"),
    meta: {
      layout: "public",
      title: "Accès refusé",
    },
  },
];

// Create Vue Router
const router = new VueRouter({
  mode: "history",
  base: "/",

  routes,

  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    }

    if (to.hash) {
      return {
        selector: to.hash,
        offset: { x: 0, y: 80 },
      };
    }

    return { x: 0, y: 0 };
  },
});

// Register authentication and role guards
createGuards({
  router,
  store,
});

// Update document title
router.afterEach((to) => {
  Vue.nextTick(() => {
    const title = to.meta.title || "ProduPneu";

    document.title = `${title} | ProduPneu.fr`;

    // Refresh animations only if initialized
    if (window.AOS && typeof window.AOS.refresh === "function") {
      window.AOS.refresh();
    }
  });
});

export default router;
